export const isEnterKey = (event) => event.key === 'Enter'
export const isSpaceKey = (event) => event.key === ' '
export const isBackspaceKey = (event) => event.key === 'Backspace'
export const isTabKey = (event) => event.key === 'Tab'
export const isCommaKey = (event) => event.key === 'Comma'
